<template>
  <BaseIdCard :numberPerRow="4" innerClass="border-b-8" :style="{'border-color': bobine.couleur.code}">
    <div class="flex flex-row justify-between gap-2">
      <div class="flex flex-col">
        <TitreDeux :content='t("coil") + " " + bobine.nombre + " - " + bobine.poidsRestant + "g"' fontSemiBold />

        <IdCardBobineReading v-if="!isEditing && !isMerging" :bobine="bobine" />
        <IdCardBobineEditing ref="editingChild" v-if="isEditing && !isMerging" :bobine="bobine" />
        <IdCardBobineMerging ref="mergingChild" v-if="isMerging" :bobine="bobine" @onMerged="isMerging = false"/>
      </div>

      <div class="flex flex-col items-start h-full">
        <OrangeWarnIcon v-show="!bobine.isDefectueuse && !isMerging" @click="toogleDefective" />
        <BlueWarnIcon v-show="bobine.isDefectueuse && !isMerging" @click="toogleDefective" />


        <GreenCheckIcon v-if="isEditing && !isMerging" @click="toogleEditMode" />
        <GreenEditIcon v-if="!isEditing && !isMerging" @click="toogleEditMode" />
        <RedTrashIcon v-if="!isMerging" @click="props.showModalDelete(bobine.uuid, bobine.poidsRestant)" class="mt-2" />
        <BlueMergeIcon @click="setMerging()" v-if="!isMerging" class="mt-2"/>
        <BlueCheckIcon v-if="isMerging" @click="mergingChildRef.merge()" class="mt-2"/>
      </div>
    </div>


    <div v-show="bobine.isDefectueuse" class="mt-2">
      <OrangeSpacer />
      <SimpleText :content='t("presumedDefective")' textCenter class="w-full flex flex-row justify-center mt-2" color="text-orange-700" />
    </div>
  </BaseIdCard>
</template>

<script setup>
import {defineProps, ref, useTemplateRef} from "vue";
import IdCardBobineReading from "@/components/organismes/IdCardBobineReading.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {NotificationStores} from "@/stores/NotificationStores";
import {BobineStore} from "@/stores/BobineStore";
import {t} from "@/utils/Traduction";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import OrangeWarnIcon from "@/components/atoms/OrangeWarnIcon.vue";
import BlueWarnIcon from "@/components/atoms/BlueWarnIcon.vue";
import IdCardBobineEditing from "@/components/organismes/IdCardBobineEditing.vue";
import BaseIdCard from "@/components/molecules/BaseIdCard.vue";
import RedTrashIcon from "@/components/atoms/RedTrashIcon.vue";
import GreenEditIcon from "@/components/atoms/GreenEditIcon.vue";
import GreenCheckIcon from "@/components/atoms/GreenCheckIcon.vue";
import BlueMergeIcon from "@/components/atoms/BlueMergeIcon.vue";
import BlueCheckIcon from "@/components/atoms/BlueCheckIcon.vue";
import IdCardBobineMerging from "@/components/organismes/IdCardBobineMerging.vue";
import OrangeSpacer from "@/components/atoms/OrangeSpacer.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";

const bobineStore = BobineStore();
const notificationStore = NotificationStores();

const props = defineProps({
  bobine: {
    type: Object,
    required: true
  },
  showModalDelete: {
    type: Function,
    required: true
  },
});

const editingChildRef = useTemplateRef('editingChild');
const mergingChildRef = useTemplateRef('mergingChild');
const isEditing = ref(false);
const isMerging = ref(false);

const toogleEditMode = () => {

  if(isEditing.value) {
    editingChildRef.value.saveChanges();
  }

  isEditing.value = !isEditing.value;
}

const setMerging = () => {
  isMerging.value = !isMerging.value;
}

const toogleDefective = () => {
  xhr.addRequestToQueue("PUT", `/bobines/${props.bobine.uuid}/defective`, undefined, true, true, false,
  (response) => {
    if(response.code !== 204) {
      if(response.code === 0 || !jsonValidator.validate(response.response)) {
        notificationStore.addNotification(
            t("errorSetCoilDefective"),
            "error");
      } else {
        notificationStore.addNotification(
            JSON.parse(response.response).message,
            "error");
      }
    } else {
      const bobine = bobineStore.bobines.find(bobine => bobine.uuid === props.bobine.uuid)

      if(bobine.isDefectueuse) {
        bobine.isDefectueuse = false;
        notificationStore.addNotification(
            t("successSetCoilUndefective"),
            "success");

      } else {
        bobine.isDefectueuse = true;
        notificationStore.addNotification(
            t("successSetCoilDefective"),
            "success");
      }
    }
  });
}

</script>

<style scoped>

</style>